import { RoomScene } from "./RoomScene";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Translation } from "../../Translation";

export class WinningHandsLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        if (!this.scene.sys.game.device.os.desktop) {
            const background = new Phaser.GameObjects.Graphics(this.scene);
            background.fillStyle(0x000000, .01);
            background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
            background.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
            background.on("pointerup", () => {
                RoomScene.currentInstance.removeWinningHandsLayer();
            });
            this.add(background);
        }

        const midContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, 0);
        midContainer.setScale(.9 * GameVars.scaleX, .9);
        midContainer.y = 66;
        this.add(midContainer);

        const image = new Phaser.GameObjects.Image(this.scene, 0, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "winning_hands.png");
        midContainer.add(image);

        const title = new Phaser.GameObjects.Text(this.scene, 0, 29, Translation.getText("POKER_HANDS_IN_TEXAS_HOLD_EM"), { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#ffffff" });
        title.setOrigin(.5);
        midContainer.add(title);

        // textos

        let text: Phaser.GameObjects.Text;
        let off = 58.5;
        let values = [
            Translation.getText("ROYAL_FLUSH"),
            Translation.getText("STRAIGHT_FLUSH"),
            Translation.getText("FOUR_OF_A_KIND"),
            Translation.getText("FULL_HOUSE"),
            Translation.getText("FLUSH"),
            Translation.getText("STRAIGHT"),
            Translation.getText("THREE_OF_A_KIND"),
            Translation.getText("TWO_PAIR"),
            Translation.getText("PAIR"),
            Translation.getText("HIGH_CARD")
        ];

        for (let i = 0; i < values.length; i++) {

            text = new Phaser.GameObjects.Text(this.scene, -25, 72 + off * i, values[i], { fontFamily: "Oswald-Medium", fontSize: "17px", color: "#ffffff" });
            text.setOrigin(1, .5);
            midContainer.add(text);
        }

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
    }
}
